import { OntarioObstetricalFileClickableTextContext } from "@/Common/Models/UI/ClickableTextContext";
import { BaseOntarioObstetricalFileSubSection, BaseOntarioObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/Ontario/Subcomponent/BaseOntarioObstetricalFileSubSection";
import { IssueAndPlanOfManagement } from "@/Patient/Models/ObstetricalFile/Ontario/OPR3/IssueAndPlanOfManagement";

class OntarioObstetricalFileIssuesPlanOfManagementState {
    public issueAndPlanOfManagementRows: IssueAndPlanOfManagement[];
}

class OntarioObstetricalFileIssuesPlanOfManagement extends BaseOntarioObstetricalFileSubSection<BaseOntarioObstetricalFileSubSectionProps, OntarioObstetricalFileIssuesPlanOfManagementState> {
    constructor(props: BaseOntarioObstetricalFileSubSectionProps) {
        super(props);
        const initialState = new OntarioObstetricalFileIssuesPlanOfManagementState();
        initialState.issueAndPlanOfManagementRows = props.form.Opr3.IssuePlanOfManagement?.map(p => new IssueAndPlanOfManagement(p)).filter(p => p.hasValue()) ?? [];
        initialState.issueAndPlanOfManagementRows.push(new IssueAndPlanOfManagement());

        this.state = initialState;
    }

    public render(): JSX.Element {
        return (
            <div className="section border border-top">
                <div className="row">
                    <div className="col-md-5">
                        {this.renderSubTitle("ObstetricalFile_IssuesLabel")}
                    </div>
                    <div className="col-md-7">
                        {this.renderSubTitle("ObstetricalFile_PlanOfManagementLabel")}
                    </div>
                </div>
                {this.state.issueAndPlanOfManagementRows.map(issueAndPlan => this.RenderIssueAndPlanSection(issueAndPlan))}
            </div>
        );
    }

    private RenderIssueAndPlanSection(issuePlanOfManagement: IssueAndPlanOfManagement): JSX.Element {
        const issueId = `opr3-issues-${issuePlanOfManagement.getId().toString()}`;
        const planOfManagementId = `opr3-management-plan-${issuePlanOfManagement.getId().toString()}`;

        return (
            <div
                className="row row-form"
                key={issuePlanOfManagement.getId().toString()}
                id={issuePlanOfManagement.getId().toString()}
            >
                <div className="col-md-5">
                    {this.controlRenderer.renderResizableTextarea({
                        value: issuePlanOfManagement.Issues,
                        onChange: value => this.mutateIssuePlanOfManagementState(issuePlanOfManagement.getId(), p => p.Issues = value),
                        id: issueId,
                        clickableTextOptions: this.getClickableTextOptions(issueId, OntarioObstetricalFileClickableTextContext.Opr3_IssuesComment, true),
                        containerCssClass: "resizable",
                        minHeight: "32px"
                    })}
                </div>
                <div className="col-md-7">
                    {this.controlRenderer.renderResizableTextarea({
                        value: issuePlanOfManagement.PlanOfManagementOrMedicationChangeOrConsultations,
                        onChange: value => this.mutateIssuePlanOfManagementState(issuePlanOfManagement.getId(), p => p.PlanOfManagementOrMedicationChangeOrConsultations = value),
                        id: planOfManagementId,
                        clickableTextOptions: this.getClickableTextOptions(planOfManagementId, OntarioObstetricalFileClickableTextContext.Opr3_PlanOfManagement),
                        containerCssClass: "resizable",
                        minHeight: "32px"
                    })}
                </div>
            </div>
        );
    }

    private mutateIssuePlanOfManagementState(id: number, mutation: (state: IssueAndPlanOfManagement) => void): void {
        let updateForm = false;
        this.mutateState(
            s => {
                s.issueAndPlanOfManagementRows = s.issueAndPlanOfManagementRows.mutate(
                    p => mutation(p),
                    p => p.getId() === id
                );

                let lastRowIndex = s.issueAndPlanOfManagementRows.length - 1;

                // Remove empty rows before last row.
                for (let i = 0; i < lastRowIndex && s.issueAndPlanOfManagementRows.any(); i++) {
                    if (s.issueAndPlanOfManagementRows[i].hasValue())
                        continue;

                    updateForm = true;
                    s.issueAndPlanOfManagementRows.splice(i, 1);
                    i--;
                    lastRowIndex--;
                }

                if (s.issueAndPlanOfManagementRows[lastRowIndex].hasValue())
                    s.issueAndPlanOfManagementRows.push(new IssueAndPlanOfManagement());
            },
            () => {
                if (updateForm)
                    this.props.mutateModelStateWithFormUpdate(s => s.Opr3.IssuePlanOfManagement = this.state.issueAndPlanOfManagementRows);
                else
                    this.props.mutateModelState(s => s.Opr3.IssuePlanOfManagement = this.state.issueAndPlanOfManagementRows);
            }
        );
    }
}

export { OntarioObstetricalFileIssuesPlanOfManagement };
